type ConversationMessagePage = {
    readonly messages: ReadonlyArray<{ readonly id: string }>;
};

export function conversationPagesIncludeMessage(
    pages: ReadonlyArray<ConversationMessagePage> | undefined,
    messageId: string | null | undefined,
): boolean {
    if (!messageId || !pages) {
        return false;
    }
    return pages.some((page) =>
        page.messages.some((message) => message.id === messageId),
    );
}

export function shouldAutoloadNextConversationPage({
    autoLoadAllPages,
    autoLoadUntilMessageId,
    pages,
    isReachingEnd,
    isValidating,
    loadedPageCount,
    requestedSize,
}: {
    readonly autoLoadAllPages: boolean;
    readonly autoLoadUntilMessageId?: string | null;
    readonly pages: ReadonlyArray<ConversationMessagePage> | undefined;
    readonly isReachingEnd: boolean;
    readonly isValidating: boolean;
    readonly loadedPageCount: number;
    readonly requestedSize: number;
}): boolean {
    if (!pages || pages.length === 0) {
        return false;
    }
    if (isReachingEnd || isValidating || loadedPageCount < requestedSize) {
        return false;
    }
    if (autoLoadAllPages) {
        return true;
    }
    if (!autoLoadUntilMessageId) {
        return false;
    }
    return !conversationPagesIncludeMessage(pages, autoLoadUntilMessageId);
}
